import { type PaymentMethodEntity, type PaymentMethodCardEntity, PaymentMethodEntityType } from '~/apiClient';

export function isCardPaymentMethod(paymentMethod: PaymentMethodEntity): paymentMethod is PaymentMethodEntity & { card: PaymentMethodCardEntity } {
    return paymentMethod.type === PaymentMethodEntityType.card && paymentMethod.card !== undefined;
}
